/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Scheduled/view.blocks to change it.
import More from './More/index'
import Primary from './Primary/index'
import React from 'react'
import Secondary from './Secondary/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Scheduled({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Scheduled.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Primary
  viewPath={`${viewPath}/Primary`}
/>
<Secondary
  viewPath={`${viewPath}/Secondary`}
/>
</div>
<More
  viewPath={`${viewPath}/More`}
/>
{children}
</React.Fragment>)
}